import React, { useState, useEffect, useRef } from "react";

import { Button, Form, Row, Col } from "react-bootstrap";

import Modal from "react-bootstrap/Modal";

import {
   BarChart,
   Bar,
   Rectangle,
   XAxis,
   YAxis,
   CartesianGrid,
   Tooltip,
   Legend,
   ResponsiveContainer,
   Cell,
} from "recharts";

const initalValues = [
   { name: "Januar", 2022: 6, 2023: 8, 2024: 17, 2025: 21 },
   { name: "Februar", 2022: 17, 2023: 11, 2024: 21, 2025: 17 },
   { name: "März", 2022: 14, 2023: 18, 2024: 21, 2025: 31 },
   { name: "April", 2022: 15, 2023: 16, 2024: 22, 2025: 28 },
   { name: "Mai", 2022: 16, 2023: 13, 2024: 16, 2025: 19 },
   { name: "Juni", 2022: 12, 2023: 19, 2024: 32, 2025: 24 },
   { name: "Juli", 2022: 13, 2023: 25, 2024: 27, 2025: 29 },
   { name: "August", 2022: 8, 2023: 21, 2024: 21, 2025: 29 },
   { name: "September", 2022: 9, 2023: 15, 2024: 25, 2025: 29 },
   { name: "Oktober", 2022: 11, 2023: 15, 2024: 16, 2025: 22 },
   { name: "November", 2022: 12, 2023: 22, 2024: 23, 2025: 35 },
   { name: "Dezember", 2022: 17, 2023: 21, 2024: 27, 2025: 22 },
];
const initalEinkaufValues = [
   { name: "Januar", 2023: 83, 2024: 194, 2025: 164 },
   { name: "Februar", 2023: 122, 2024: 145, 2025: 183 },
   { name: "März", 2023: 119, 2024: 150, 2025: 198 },
   { name: "April", 2023: 115, 2024: 152, 2025: 200 },
   { name: "Mai", 2023: 91, 2024: 115, 2025: 146 },
   { name: "Juni", 2023: 89, 2024: 151, 2025: 147 },
   { name: "Juli", 2023: 95, 2024: 140, 2025: 144 },
   { name: "August", 2023: 83, 2024: 90, 2025: 121 },
   { name: "September", 2023: 111, 2024: 114, 2025: 159 },
   { name: "Oktober", 2023: 142, 2024: 123, 2025: 163 },
   { name: "November", 2023: 127, 2024: 170, 2025: 185 },
   { name: "Dezember", 2023: 60, 2024: 79, 2025: 106 },
];
const intitalYearValues = {
   name: "Gesamt",
   2022: 150,
   2023: 204,
   2024: 268,
   2025: 306,
};
export default function ProjektstatusStatistik({
   /* userObjects,
   abschnittsarray,
   showStatusStufen, */
   einkaufstermine,
   objectAbwicklungen,
   allNotartermine,
}) {
   const [show, setShow] = useState(false);
   const [pageFormat, setPageFormat] = useState("l");
   const [sortedItems, setSortedItems] = useState([]);
   const [maxCounter, setMaxCounter] = useState(1);
   const [statData, setStatData] = useState(initalValues);
   const [ektData, setEktData] = useState(initalEinkaufValues);
   const [yearValues, setYearValues] = useState(intitalYearValues);
   const [salesSum, setSalesSum] = useState();
   const [salesAmmount, setSalesAmmount] = useState();

   useEffect(() => {
      if (einkaufstermine) {
         const heute = new Date();
         const pastDates = {};
         const futureDates = {};
         const nextYearDates = {};
         let currentYear = heute.getFullYear();
         let pastYear = currentYear - 1;
         let nextYear = currentYear + 1;

         einkaufstermine.forEach((item) => {
            const parsedDatum = new Date(item.datum);
            let monat = parsedDatum.getMonth();

            if (parsedDatum < heute) {
               if (pastDates[monat]) {
                  pastDates[monat] += 1;
               } else {
                  pastDates[monat] = 1;
               }
            } else {
               if (parsedDatum.getFullYear() > currentYear) {
                  if (nextYearDates[monat]) {
                     nextYearDates[monat] += 1;
                  } else {
                     nextYearDates[monat] = 1;
                  }
               } else {
                  if (futureDates[monat]) {
                     futureDates[monat] += 1;
                  } else {
                     futureDates[monat] = 1;
                  }
               }
            }
         });
         // console.log(pastDates);

         setEktData((prev) => {
            const newData = prev.map((item, index) => {
               const newItem = { ...item };

               newItem[currentYear] = pastDates[index] ? pastDates[index] : 0;
               newItem[currentYear + " (offen)"] = futureDates[index] ? futureDates[index] : 0;
               newItem[nextYear + " (offen)"] = nextYearDates[index] ? nextYearDates[index] : 0;
               return newItem;
            });

            return newData;
         });
      }
   }, [einkaufstermine]);

   useEffect(() => {
      const heute = new Date();
      let currentYear = heute.getFullYear();
      // currentYear = 2025;
      let pastYear = currentYear - 1;
      let nextYear = currentYear + 1;

      // currentYear=2025
      // nextYear=2026

      if (allNotartermine && objectAbwicklungen) {
         setYearValues((prev) => ({
            ...prev,
            [currentYear]: allNotartermine.filter((item) => new Date(item.datum).getFullYear() === currentYear).length,
            [nextYear]: allNotartermine.filter((item) => new Date(item.datum).getFullYear() === nextYear).length,
         }));

         const pastDates = {};
         const futureDates = {};
         const nextYearDates = {};
         let newSalesData = {};

         console.log(allNotartermine);
         
         allNotartermine.forEach((item) => {
            const benutzer = objectAbwicklungen[item.id] ? objectAbwicklungen[item.id].benutzer : false;

            const parsedDatum = new Date(item.datum);
            let monat = parsedDatum.getMonth();

            if (parsedDatum < heute) {
               if (benutzer) {
                  if (newSalesData[benutzer]) {
                     newSalesData[benutzer] = {
                        zahl: newSalesData[benutzer].zahl + 1,
                        wert: newSalesData[benutzer].wert + parseFloat(objectAbwicklungen[item.id].verkauft_fur),
                     };
                  } else {
                     newSalesData[benutzer] = {
                        zahl: 1,
                        wert: parseFloat(objectAbwicklungen[item.id].verkauft_fur),
                     };
                  }
               }
               if (pastDates[monat]) {
                  pastDates[monat] += 1;
               } else {
                  pastDates[monat] = 1;
               }
            } else {
               if (parsedDatum.getFullYear() > currentYear) {
                  if (nextYearDates[monat]) {
                     nextYearDates[monat] += 1;
                  } else {
                     nextYearDates[monat] = 1;
                  }
               } else {
                  if (futureDates[monat]) {
                     futureDates[monat] += 1;
                  } else {
                     futureDates[monat] = 1;
                  }
               }
            }
         });
         setStatData((prev) => {
            const newData = prev.map((item, index) => {
               const newItem = { ...item };
               newItem[currentYear] = pastDates[index] ? pastDates[index] : 0;
               newItem[currentYear + " (offen)"] = futureDates[index] ? futureDates[index] : 0;
               newItem[nextYear + " (offen)"] = nextYearDates[index] ? nextYearDates[index] : 0;
               return newItem;
            });

            return newData;
         });

         /*   console.log(
        Object.keys(newSalesData).map((item) => ({
          zahl: newSalesData[item].zahl,
          wert: newSalesData[item].wert,
          name: [userObjects[item].Vorname[0] + ". " + userObjects[item].Nachname],
        }))
      ); 

      setSalesSum(
        Object.keys(newSalesData)
          .map((item) => ({
            zahl: newSalesData[item].zahl,
            wert: newSalesData[item].wert,
            name: [userObjects[item].Vorname[0] + ". " + userObjects[item].Nachname],
          }))
          .sort((a, b) => b.wert - a.wert)
      );*/
      }
   }, [allNotartermine, objectAbwicklungen]);

   useEffect(() => {
      let x = window.matchMedia("(max-width: 700px)");
      x.addEventListener("change", () => {
         if (x.matches) {
            // If media query matches

            console.log("p");
            setPageFormat("p");
         } else {
            setPageFormat("l");

            console.log("l");
         }
      });
   }, []);

   function renderCustomBarLabel({ payload, x, y, width, height, value, altLabel, isCurrency }) {
      return (
         <text x={x + width / 2} y={y} fill="#eef" fontWeight={500} textAnchor="middle" dy={-7}>
            {isCurrency ? (
               <tspan textAnchor="middle">
                  {new Intl.NumberFormat("de-DE", {
                     style: "currency",
                     currency: "EUR",
                     maximumFractionDigits: 0,
                  }).format(value)}
               </tspan>
            ) : (
               <tspan textAnchor="middle">{value ? value : ""}</tspan>
            )}
            {altLabel && (
               <tspan textAnchor="middle" x={x + width / 2} y={y - 24}>
                  {altLabel}
               </tspan>
            )}
         </text>
      );
   }

   return (
      <div className="projektstatus-l2 projektstatus-statistik">
         <div
            style={{
               margin: "auto",
               minWidth: "100%",
               maxWidth: pageFormat === "p" ? "100vw" : "40vw",
            }}
         >
            <div>
               <h2 style={{ backgroundColor: "#0004", margin: 0, paddingTop: "8px" }}>Verkaufte Objekte</h2>
               <ResponsiveContainer
                  style={{ background: "linear-gradient(180deg, #0004 0%, #0000 100%)" }}
                  width={"100%"}
                  height={400}
               >
                  <BarChart
                     data={statData}
                     margin={{
                        top: 30,
                        right: 0,
                        left: 0,
                        bottom: 5,
                     }}
                  >
                     <XAxis dataKey="name" type="category" tick={{ fill: "#eef", fontSize: "x-small" }} />
                     <YAxis type="number" tick={{ fill: "#eef", fontSize: "small" }} />

                     <Legend /* content={(e)=>renderCustomLabel({...e})} */ />
                     <Bar dataKey="2022" fill="#7286D3" label={renderCustomBarLabel} />
                     <Bar dataKey="2023" fill="#8EA7E9" label={renderCustomBarLabel} />
                     <Bar dataKey="2024" fill="#E5E0FF" label={renderCustomBarLabel} />
                     <Bar dataKey="2025" fill="#FFF5F5" label={renderCustomBarLabel} />
                     {/* <Bar stackId="a" dataKey="2025 (offen)" fill="#FFF5F588" label={renderCustomBarLabel} /> */}

                     <Bar stackId="a" dataKey="2026" fill="#FFF" label={renderCustomBarLabel} />
                     <Bar stackId="a" dataKey="2026 (offen)" fill="#FFFFFF88" label={renderCustomBarLabel} />
                  </BarChart>
               </ResponsiveContainer>

               <h2 style={{ backgroundColor: "#0004", margin: 0, paddingTop: "8px" }}></h2>
               <ResponsiveContainer
                  style={{ padding: "0 25%", background: "linear-gradient(180deg, #0004 0%, #0000 100%)" }}
                  width={"100%"}
                  height={400}
               >
                  <BarChart
                     data={[yearValues]}
                     margin={{
                        top: 30,
                        right: 0,
                        left: 0,
                        bottom: 5,
                     }}
                  >
                     <XAxis dataKey="name" type="category" tick={{ fill: "#eef", fontSize: "x-small" }} />
                     <YAxis type="number" tick={{ fill: "#eef", fontSize: "small" }} />

                     <Legend />
                     <Bar dataKey="2022" fill="#7286D3" label={renderCustomBarLabel} />
                     <Bar dataKey="2023" fill="#8EA7E9" label={renderCustomBarLabel} />
                     <Bar dataKey="2024" fill="#E5E0FF" label={renderCustomBarLabel} />
                     <Bar dataKey="2025" fill="#FFF5F5" label={renderCustomBarLabel} />
                     <Bar dataKey="2026" fill="#FFFFFF" label={renderCustomBarLabel} />
                  </BarChart>
               </ResponsiveContainer>

               <h2 style={{ backgroundColor: "#0004", margin: 0, paddingTop: "8px" }}>Einkaufstermine</h2>
               <ResponsiveContainer
                  style={{ background: "linear-gradient(180deg, #0004 0%, #0000 100%)" }}
                  width={"100%"}
                  height={400}
               >
                  <BarChart
                     data={ektData}
                     margin={{
                        top: 30,
                        right: 0,
                        left: 0,
                        bottom: 5,
                     }}
                  >
                     <XAxis dataKey="name" type="category" tick={{ fill: "#eef", fontSize: "x-small" }} />
                     <YAxis type="number" tick={{ fill: "#eef", fontSize: "small" }} />

                     <Legend /* content={(e)=>renderCustomLabel({...e})} */ />

                     <Bar dataKey="2023" fill="#5E97b9" label={renderCustomBarLabel} />
                     <Bar dataKey="2024" fill="#8EA7E9" label={renderCustomBarLabel} />
                     {/* <Bar dataKey="2024" fill="#E5E0FF" label={renderCustomBarLabel} /> */}
                     <Bar
                        stackId="a"
                        dataKey="2025"
                        fill="#FFF5F5"
                        label={(e) => renderCustomBarLabel({ ...e, altLabel: "" })}
                        altLabel="abc"
                     />
                     <Bar stackId="b" dataKey="2026" fill="#FFFFFF" label={renderCustomBarLabel} />
                     <Bar stackId="b" dataKey="2026 (offen)" fill="#FFFFFF88" label={renderCustomBarLabel} />
                  </BarChart>
               </ResponsiveContainer>
               {/* 
          {salesSum && (
            <ResponsiveContainer width={"100%"} height={400}>
              <BarChart
                data={salesSum}
                margin={{
                  top: 30,
                  right: 0,
                  left: 0,
                  bottom: 5,
                }}
              >
                <XAxis
                  dataKey="name"
                  type="category"
                  tick={{ fill: "#eef", fontSize: "x-small" }}
                />
                <YAxis type="number" tick={{ fill: "#eef", fontSize: "0" }} />
                <Bar
                  dataKey={"wert"}
                  fill="#E5E0FF"
                  barCategoryGap={10}
                  barSize={50}
                  label={(e) =>
                    renderCustomBarLabel({ ...e, isCurrency: true })
                  }
                >
                  {salesSum.map((item, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={`rgba(255, 190, 0, ${0.1 + 0.9 * (1 / (1 + index))})`}
                    />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          )} */}
            </div>
         </div>
      </div>
   );
}
